import { useEffect, useState } from "react";
import TermContent from "src/components/seller/Terms/TermContent";
import TermContentEn from "src/components/seller/Terms/TermContentEn";

const Terms = ({ userData, hideHeader = false }) => {
  const [contractPercent, setContactPercent] = useState({
    desc: "10%",
    fee: "10%",
    feeCard: "3%",
    lang: "th",
  });

  const showEnglishTermsEmails = [
    "kloy@woodmark.com.sg",
    "zoeliu991@gmail.com",
    // "develop_charinrat.b+2@xsurface.com",
  ];

  /**
   * @notice ALWAYS change email in *case* to lowercase. because some email is uppercase and some is lowercase but email value is always lowercase,
   *         so we need to change it to lowercase before compare
   */
  const contract_percent_desc = (email = "") => {
    let percent;

    switch (email) {
      case "viwatchaiflooring@gmail.com":
        percent = "10%";
        break;
      case "chutidech@future-tech.co.th":
        percent = "25%";
        break;
      case "mkt.hdp@gmail.com":
        percent = "%";
        break;
      case "deccodecorative@gmail.com":
        percent = "20%";
        break;
      case "sksdecor@gmail.com":
        percent = "10%";
        break;
      case "disayarin.decosource@gmail.com":
        percent = "30%";
        break;

      case "gifnavymi@gmail.com":
        percent = "30%";
        break;
      case "Sales@titanptc.com":
        percent = "30%";
        break;
      case "hlekhawiwat@gmail.com":
        percent = "30%";
        break;
      case "cutcarve@gmail.com":
        percent = "30%";
        break;
      case "info@finesurfacetrading.com":
        percent = "30%";
        break;
      case "pichapa.ow@remood.co.th":
        percent = "20%";
        break;
      case "info.suzukagroup@gmail.com":
        percent = "%";
        break;
      case "ying_37gan@hotmail.com":
        percent = "30%";
        break;
      case "salewallpod@phi-flexiplan.com":
        percent = "30%";
        break;
      case "wawelldecor@gmail.com":
        percent = "30%";
        break;
      case "jfttechnology.sales@gmail.com":
        percent = "30%";
        break;
      case "abdulrohmanmahasae2@gmail.com":
        percent = "30%";
        break;
      case "kittikun@space1.co.th":
        percent = "30%";
        break;
      case "patcharaporn@choisimaterials.com":
        percent = "30%";
        break;
      case "ecommerce@shera.com":
        percent = "30%";
        break;
      case "zoeliu991@gmail.com":
        percent = "30%";
        break;
      case "info@atlasthailand.com":
        percent = "30%";
        break;
      case "thansita@alloysolutions.asia":
        percent = "30%";
        break;
      case "marketing@vispac.co.th":
        percent = "30%";
        break;
      case "2283024081@qq.com":
        percent = "30%";
        break;
      case "kaminjitsangboon@gmail.com":
        percent = "30%";
        break;
      case "oceanrockdecor@gmail.com":
        percent = "30%";
        break;
      case "projectsales1.alusite@gmail.com":
        percent = "30%";
        break;
      case "info.decormat@gmail.com":
        percent = "20%";
        break;
      case "chame48610@gmail.com":
        percent = "30%";
        break;
      case "miya@tomagalglobal.com":
        percent = "30%";
        break;
      case "rcasale2526@gmail.com":
        percent = "30%";
        break;
      case "curtainandmore@gmail.com":
        percent = "30%";
        break;
      default:
        percent = "10%";
    }
    return percent;
  };

  /**
   * @notice ALWAYS change email in *case* to lowercase. because some email is uppercase and some is lowercase but email value is always lowercase,
   *         so we need to change it to lowercase before compare
   */
  const contract_percent_fee = (email = "") => {
    let percent;

    switch (email) {
      case "viwatchaiflooring@gmail.com":
        percent = "10%";
        break;
      case "chutidech@future-tech.co.th":
        percent = "25%";
        break;
      case "mkt.hdp@gmail.com":
        percent = `พรม 15% \n
          ฟิล์ม 20% \n
          หินสังเคราะห์ 13% \n
          หินควอท์ 15% \n
          เฟรมอลูมิเนียม 15% \n
          ชุดครัว 15%\n`;
        break;
      case "info.suzukagroup@gmail.com":
        percent = `PU  30%  \n  
          สีพ่นเท็กเจอร์ 10%`;
        break;
      case "deccodecorative@gmail.com":
        percent = "20%";
        break;
      case "disayarin.decosource@gmail.com":
        percent = "30%";
        break;
      case "sksdecor@gmail.com":
        percent = "10%";
        break;
      case "pichapa.ow@remood.co.th":
        percent = "20%";
        break;
      case "ying_37gan@hotmail.com":
        percent = "30%";
        break;
      case "salewallpod@phi-flexiplan.com":
        percent = "30%";
        break;
      case "wawelldecor@gmail.com":
        percent = "30%";
        break;
      case "jfttechnology.sales@gmail.com":
        percent = "30%";
        break;
      case "abdulrohmanmahasae2@gmail.com":
        percent = "30%";
        break;
      case "kittikun@space1.co.th":
        percent = "30%";
        break;
      case "patcharaporn@choisimaterials.com":
        percent = "30%";
        break;
      case "ecommerce@shera.com":
        percent = "30%";
        break;
      case "zoeliu991@gmail.com":
        percent = "30%";
        break;
      case "info@atlasthailand.com":
        percent = "30%";
        break;
      case "thansita@alloysolutions.asia":
        percent = "30%";
        break;
      case "marketing@vispac.co.th":
        percent = "30%";
        break;
      case "2283024081@qq.com":
        percent = "30%";
        break;
      case "kaminjitsangboon@gmail.com":
        percent = "30%";
        break;
      case "oceanrockdecor@gmail.com":
        percent = "30%";
        break;

      case "gifnavymi@gmail.com":
        percent = "30%";
        break;
      case "sales@titanptc.com":
        percent = "30%";
        break;
      case "hlekhawiwat@gmail.com":
        percent = "30%";
        break;
      case "cutcarve@gmail.com":
        percent = "30%";
        break;
      case "info@finesurfacetrading.com":
        percent = "30%";
        break;
      case "projectsales1.alusite@gmail.com":
        percent = "30%";
        break;
      case "info.decormat@gmail.com":
        percent = "20%";
        break;
      case "chame48610@gmail.com":
        percent = "30%";
        break;
      case "miya@tomagalglobal.com":
        percent = "30%";
        break;
      case "rcasale2526@gmail.com":
        percent = "30%";
        break;
      case "curtainandmore@gmail.com":
        percent = "30%";
        break;
      default:
        percent = "10%";
    }
    return percent;
  };

  /**
   * @notice ALWAYS change email in *case* to lowercase. because some email is uppercase and some is lowercase but email value is always lowercase,
   *         so we need to change it to lowercase before compare
   */
  const contract_percent_fee_card = (email = "") => {
    let percent;

    switch (email) {
      case "viwatchaiflooring@gmail.com":
        percent = "3.5%";
        break;
      case "chutidech@future-tech.co.th":
        percent = "3.5%";
        break;
      case "mkt.hdp@gmail.com":
        percent = `3.5%`;
        break;
      case "info.suzukagroup@gmail.com":
        percent = `3.5%`;
        break;
      case "deccodecorative@gmail.com":
        percent = "3.5%";
        break;
      case "sksdecor@gmail.com":
        percent = "3.5%";
        break;
      case "pichapa.ow@remood.co.th":
        percent = "3.5% ";
        break;
      case "ying_37gan@hotmail.com":
        percent = "3.5%";
        break;
      case "salewallpod@phi-flexiplan.com":
        percent = "3.5%";
        break;
      case "wawelldecor@gmail.com":
        percent = "3.5%";
        break;
      case "disayarin.decosource@gmail.com":
        percent = "3.5%";
        break;
      case "jfttechnology.sales@gmail.com":
        percent = "3.5%";
        break;
      case "abdulrohmanmahasae2@gmail.com":
        percent = "3.5%";
        break;
      case "kittikun@space1.co.th":
        percent = "3.5%";
        break;
      case "patcharaporn@choisimaterials.com":
        percent = "3.5%";
        break;
      case "ecommerce@shera.com":
        percent = "3.5%";
        break;
      case "zoeliu991@gmail.com":
        percent = "3.5%";
        break;
      default:
        percent = "3.5%";
    }
    return percent;
  };

  useEffect(() => {
    if (!userData) return;

    let formatEmail = userData?.email?.toLowerCase();
    setContactPercent({
      desc:
        userData?.terms_contract?.percent_fee?.length > 1
          ? "%"
          : userData?.terms_contract?.percent_fee[0]?.percent ||
            contract_percent_desc(formatEmail),
      fee:
        userData?.terms_contract?.percent_fee?.length > 1
          ? userData?.terms_contract?.percent_fee
              ?.map((item) => `${item.description} ${item.percent}`)
              .join("\n") + "\n"
          : userData?.terms_contract?.percent_fee[0]?.percent ||
            contract_percent_fee(formatEmail),
      feeCard:
        userData?.terms_contract?.percent_card ||
        contract_percent_fee_card(formatEmail),
      lang: userData?.terms_contract?.language
        ? userData?.terms_contract?.language
        : showEnglishTermsEmails.includes(userData?.email)
          ? "en"
          : "th",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData]);

  return (
    <>
      {contractPercent?.lang === "en" ? (
        <TermContentEn
          contractPercent={contractPercent}
          userData={userData}
          hideHeader={hideHeader}
        />
      ) : (
        <TermContent
          contractPercent={contractPercent}
          userData={userData}
          hideHeader={hideHeader}
        />
      )}
    </>
  );
};

export default Terms;
